<template>
  <v-container
    fluid
    justify-start
    >
    <v-list-item>
      <v-list-item-avatar class="mr-2 pb-2">
        <v-icon
          x-large
          color="amber"
          >
          highlight
        </v-icon>
      </v-list-item-avatar>
      <v-list-item-title class="display-2 pb-2 mb-1 font-weight-medium blue--text text--lighten-3">
        Bull Finder Lite
      </v-list-item-title>
    </v-list-item>
    
    <bull-finder-lite-container class="mb-3" />
  </v-container>
</template>

<script>
import BullFinderLiteContainer from '@/components/BullFinderLiteContainer'

export default {
  name: 'BullFinderLite',
  components: {
    BullFinderLiteContainer
  }
}
</script>
